import config from "../config/config";

export function isValidEmail(email) {
  const s = String(email || "").trim();
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(s);
}

/** Absolute URL to the hosted product catalog PDF. */
export function getBrochureFileUrl() {
  return config.getBrochureCatalogUrl();
}

function getBrochureFilename() {
  return config.brochureCatalogFilename;
}

async function triggerFileDownload(url, filename) {
  try {
    const res = await fetch(url, { mode: "cors" });
    if (!res.ok) throw new Error("Brochure file not found");
    const blob = await res.blob();
    const objectUrl = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = objectUrl;
    a.download = filename;
    a.rel = "noopener noreferrer";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(objectUrl);
  } catch {
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    a.target = "_blank";
    a.rel = "noopener noreferrer";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }
}

async function recordBrochureRequest(email) {
  try {
    await fetch(config.getApiUrl("submit_contact_form.php"), {
      method: "POST",
      headers: config.getApiHeaders(),
      body: JSON.stringify({
        name: "Brochure download",
        email: email.trim(),
        message: "Requested NCG Corporate brochure download from the website.",
        subject: "Brochure download",
      }),
    });
  } catch {
    /* ignore — download still proceeds */
  }
}

/**
 * Validates email, optionally logs lead, downloads brochure PDF from the catalog URL.
 * @returns {{ ok: true } | { ok: false, error: string }}
 */
export async function requestBrochureDownload(email) {
  if (!isValidEmail(email)) {
    return { ok: false, error: "Please enter a valid email address." };
  }

  void recordBrochureRequest(email);

  try {
    await triggerFileDownload(getBrochureFileUrl(), getBrochureFilename());
  } catch {
    return {
      ok: false,
      error:
        "Could not download the brochure. Please try again or open the catalog from ncgcorporate.com.",
    };
  }

  return { ok: true };
}
